import React from 'react'
import './Carousel.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import 'swiper/swiper-bundle.css'
import TrendingCard from '../trendingCard/TrendingCard';



SwiperCore.use([Navigation])

export default function Carousel({ trendingDishes }) {

 



  return (
    <React.Fragment>
      <Swiper
        breakpoints={{         
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 100
          },
          1366: {
            slidesPerView: 5,
            spaceBetween: 50
          },
          1440: {
            slidesPerView: 5,
            spaceBetween: 50
          },
          1920: {
            slidesPerView: 7,
            spaceBetween: 50
          }
        }}
        direction="horizontal"
        spaceBetween={10} 
        slidesPerView={1}
        loop="true"
        navigation
        >      
      
         {trendingDishes.map((trending,idx) => (
           <SwiperSlide key={idx}>
             <TrendingCard trending={trending}   />                       
           </SwiperSlide>
         ))}
     {/* {JSON.stringify(trendingDishes)} */}
      </Swiper>
    </React.Fragment>
  )
}

